import moment from 'moment'
import React from 'react'
import { Form } from 'react-bootstrap'
import useSchoolYear from '../../../hooks/use-school-year'

const SchoolYearParam = ({
    label,
    value,
    onChange = () => {}
}) => {
    const { endDate } = useSchoolYear()
    const year = moment(endDate).year()
    React.useEffect(() => {
        if (!value) {
            onChange(year)
        }
    }, [value])
    return (
        <Form.Group>
            <Form.Label>{label || 'School Year'}</Form.Label>
            <Form.Control as="select" value={value || ''} onChange={e => onChange(e.target.value)} >
                <option value={year - 1}>{year - 2} - {year - 1}</option>
                <option value={year}>{year - 1} - {year}</option>
            </Form.Control>
        </Form.Group>
    )
}

export default SchoolYearParam